Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFocused = void 0;
var _getREM = require("../../getREM");
var _useColors2 = require("./useColors");
var _reactNative = require("react-native-web");
var useFocused = exports.useFocused = function useFocused() {
  var _useColors = (0, _useColors2.useColors)(),
    COLORS = _useColors.COLORS;
  var focused = {};
  if (_reactNative.Platform.OS === 'web') {
    focused = {
      outlineColor: COLORS.studio,
      outlineWidth: (0, _getREM.getREM)(0.125),
      outlineStyle: 'solid'
    };
  }
  return {
    focused: focused
  };
};